export class AspectTextTransform {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get textBasis() {
        return this.aspect.valueOf.textBasis;
    }
    get transformedText() {
        let s = this.textBasis;
        const transformers = this.aspect.activesOf.transformText;
        for (const transform of transformers) {
            s = this.applyTransformer(transform, s);
        }
        return s;
    }
    applyTransformer(at, s) {
        const transformType = at.trait.value;
        /*
            if (transformType === 'removeUnderscores') {
              return s.replace(/_+/g, '');
            }
        */
        // Replaces underscore in Option by Association text
        if (transformType === 'choiceGap') {
            const { questionMultipleChoice } = at.context;
            if (questionMultipleChoice.choiceInfo.hasMultipleCorrectOptions || !s.includes('_'))
                return s;
            const [optionToBeSelected] = questionMultipleChoice.choiceInfo.optionsToBeSelected;
            if (!optionToBeSelected || !optionToBeSelected.text)
                return s;
            return s.replace(/_+|<span class=\"replace\">(.*?)<\/span>/g, `<span class="text-success">${optionToBeSelected.text.textOutputString}</span>`);
        }
        // Replaces underscore in Option by Association text
        if (transformType === 'associateGap') {
            const { associateOption } = this.aspect.context;
            if (associateOption.ownAssociations.length !== 1)
                return s;
            const [association] = associateOption.ownAssociations;
            if (association.isAssociationComplete) {
                return s.replace(/_+/gi, s => `<span class="text-success">${association.actorContent.local.firstTextBasis}</span>`);
            }
            return s;
        }
        if (transformType === 'kawGap') {
            // KnowAWordGap
            if (!s.includes('_'))
                return s;
            const { questionKnowAWord } = at.context;
            return s.replace(/_+|<span class=\"replace\">(.*?)<\/span>/g, `<span class="text-success">${questionKnowAWord.wordTask.wordTaskNearest.nearestWording.wordingString}</span>`);
        }
        if (transformType === 'mpGap') {
            // KnowAWordGap
            if (!s.includes('_'))
                return s;
            const { questionMemorizePoints } = at.context;
            if (!questionMemorizePoints.isOrdered)
                return s;
            let matchIndex = 0;
            return s.replace(/_+|<span class=\"replace\">(.*?)<\/span>/g, match => {
                if (matchIndex >= questionMemorizePoints.wordTasks.length)
                    return match;
                const wordTask = questionMemorizePoints.wordTasks[matchIndex];
                matchIndex++;
                if (!wordTask.taskProgress.isTaskCompleted)
                    return match;
                return `<span class="text-success">${wordTask.wordTaskNearest.nearestWording.wordingString}</span>`;
            });
        }
    }
}
